export enum PromotionType {
    All = 1,
    Featured = 2,
    Regular = 3
}
